/**
 * Product Image Swiper with Thumbnails
 */
function initProductSwiper() {
  if (typeof Swiper === 'undefined') {
    console.error('Swiper is not loaded');
    return;
  }

  // 既存のSwiperインスタンスがあれば破棄
  const existingMain = document.querySelector('.product-swiper-main');
  const existingThumbs = document.querySelector('.product-swiper-thumbs');

  if (existingMain && existingMain.swiper) {
    existingMain.swiper.destroy(true, true);
  }
  if (existingThumbs && existingThumbs.swiper) {
    existingThumbs.swiper.destroy(true, true);
  }

  // サムネイルスライダーの初期化（サムネイル要素が存在する場合のみ）
  let swiperThumbs = null;
  const thumbsElement = document.querySelector('.product-swiper-thumbs');

  if (thumbsElement) {
    swiperThumbs = new Swiper('.product-swiper-thumbs', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.swiper-button-next-thumbs',
        prevEl: '.swiper-button-prev-thumbs',
      },
      breakpoints: {
        750: {
          slidesPerView: 5,
        },
        990: {
          slidesPerView: 4,
        }
      }
    });
  }

  // メインスライダーの初期化
  const swiperConfig = {
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    loop: false,
    grabCursor: true,
  };

  // サムネイルがある場合のみthumbsを追加
  if (swiperThumbs) {
    swiperConfig.thumbs = {
      swiper: swiperThumbs,
    };
  }

  const swiperMain = new Swiper('.product-swiper-main', swiperConfig);

  // バリアント変更時の画像切り替え対応
  if (typeof PubSub !== 'undefined') {
    PubSub.subscribe('variant:change', function(data) {
      if (data && data.variant && data.variant.featured_media) {
        const mediaId = data.variant.featured_media.id;
        const slideIndex = document.querySelector(`[data-media-id="${mediaId}"]`)?.dataset.slideIndex;
        if (slideIndex !== undefined) {
          swiperMain.slideTo(parseInt(slideIndex));
        }
      }
    });
  }

  // GLightboxの初期化（PCビュー990px以上のみ）
  // Swiperの初期化後、少し待ってからLightboxを初期化
  setTimeout(() => {
    initProductLightbox();
  }, 300);
}

/**
 * GLightbox Initialization for Product Gallery (Desktop only - 990px+)
 */
let productLightbox = null;

function initProductLightbox() {
  const lightboxLinks = document.querySelectorAll('.product-image-lightbox');

  console.log('initProductLightbox called, found links:', lightboxLinks.length);

  if (!lightboxLinks.length) {
    console.warn('No lightbox links found');
    return;
  }

  // 画面幅チェック関数
  function isDesktop() {
    return window.innerWidth >= 990;
  }

  // GLightboxインスタンスの初期化
  function createLightbox() {
    if (typeof GLightbox !== 'undefined' && !productLightbox) {
      console.log('Creating GLightbox instance');
      try {
        productLightbox = GLightbox({
          selector: '.product-image-lightbox',
          touchNavigation: true,
          loop: true,
          autoplayVideos: false,
          closeOnOutsideClick: true,
          openEffect: 'zoom',
          closeEffect: 'fade',
          descPosition: 'bottom',
          skin: 'clean product-lightbox-custom'
        });
        console.log('GLightbox instance created successfully');
      } catch (error) {
        console.error('Failed to create GLightbox:', error);
      }
    } else if (typeof GLightbox === 'undefined') {
      console.warn('GLightbox is not loaded');
    }
  }

  // Lightboxリンクの有効/無効を切り替え
  function toggleLightbox() {
    const desktop = isDesktop();
    console.log('toggleLightbox called, isDesktop:', desktop);

    lightboxLinks.forEach(link => {
      if (desktop) {
        // PCビューではLightboxを有効化
        link.style.cursor = 'zoom-in';
        link.style.pointerEvents = 'auto';
        link.removeAttribute('onclick');

        // GLightboxインスタンスを作成（まだ作成されていない場合）
        if (!productLightbox) {
          createLightbox();
        }
      } else {
        // モバイル/タブレットではLightboxを無効化
        link.style.cursor = 'default';
        link.style.pointerEvents = 'none';
        link.setAttribute('onclick', 'return false;');
      }
    });
  }

  // 初期化時に実行（defer属性により確実に読み込まれている）
  toggleLightbox();

  // リサイズ時に再チェック（デバウンス処理）
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(toggleLightbox, 250);
  });
}

// Swiperライブラリが読み込まれるまで待つ
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    // Swiperが読み込まれるまで少し待つ
    setTimeout(initProductSwiper, 100);
  });
} else {
  setTimeout(initProductSwiper, 100);
}
